import { AddAction } from './AddAction.js';
import { DeleteAction } from './DeleteAction.js';
import { LoadAction } from './LoadAction.js';
import { RotateAction } from './RotateAction.js';
import { TranslateAction } from './TranslateAction.js';

export enum ActionSideEffectTypesEnum {
  Stacking = 'stacking',
}

export type CommanderActions =
  | TranslateAction
  | DeleteAction
  | RotateAction
  | LoadAction
  | AddAction;

export interface BaseActionSideEffect {
  type: ActionSideEffectTypesEnum;
}

export interface StackingSideEffect extends BaseActionSideEffect {
  type: ActionSideEffectTypesEnum.Stacking;
  selector: string;
  parent?: string | null;
  positionY: number;
}

export type ActionSideEffect = StackingSideEffect;
